import {
	ROUTE_BANKID,
	ROUTE_MOBILE_QUICK_DEPOSIT,
	ROUTE_SHOP_DETAIL,
	ROUTE_PROMOTIONS_DETAIL,
	ROUTE_FREE_TO_PLAY_DETAIL
} from '~/components/router/constants.js';

export default [
	ROUTE_BANKID,
	ROUTE_MOBILE_QUICK_DEPOSIT,
	ROUTE_SHOP_DETAIL,
	ROUTE_PROMOTIONS_DETAIL,
	ROUTE_FREE_TO_PLAY_DETAIL
].map(i => (i.startsWith('/') ? i : `/${i}`));
